import React from "react";

const categories = ["Take Away", "Dine in", "Completed", "Cancelled", "No Show"];

function CatagoriesOrder({
  activeCategory,
  onSelectCategory,
  requestTakeAway,
  requestDineIn,
}) {
  return (
    <div className="category-filter">
      {categories.map((category, index) => (
        <div key={index} className="category-item">
          <button
            className={`category-button ${
              activeCategory === category ? "active" : ""
            }`}
            onClick={() => onSelectCategory(category)}
          >
            {category}
          </button>
          {/* Render notification badge for 'Take Away' and 'Dine in' */}
          {(category === "Take Away" || category === "Dine in") &&
            activeCategory !== category && // Ensure it's not the active category
            ((category === "Take Away" && requestTakeAway > 0) || // Check for non-zero Take Away requests
              (category === "Dine in" && requestDineIn > 0)) && ( // Check for non-zero Dine In requests
              <button className="notification-badge">
                {category === "Take Away" ? requestTakeAway : requestDineIn}
              </button>
            )}
        </div>
      ))}
    </div>
  );
}

export default CatagoriesOrder;
